import React, {Fragment} from "react"
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'

export default class ProgressBar extends React.Component {
  constructor(props) {
    super(props)

    this.config = { 
      types : [
        {
          title: 'default',
          isDefault: true,
        },
      ],
      modifiers : [ 
        'inverse'
      ],
      states : []
    }

    this.renderProgressbar = this.renderProgressbar.bind(this);
  }

renderPercentage() { 
  let percentage = (this.props.value)*100/(this.props.progress);
  return percentage
}

renderProgressbar(value, progress) {

  if (this.props.isVisible) { 
    let sliderValueBar = this.renderPercentage();
    return <Fragment>
      <div className="mdn-ProgressBar-percent" style={{left:sliderValueBar.toFixed(2)+"%", }} >
        <p className="mdn-ProgressBar-percentText mdn-Heading">{sliderValueBar.toFixed(0)}%</p>
      </div>
      <progress className="mdn-ProgressBar-fill" value={this.props.value}  max={this.props.progress}></progress> 
    </Fragment>
  }
}
  render() {
    const { value, isVisible, progress, ...rest } = this.props
    return  <div {...rest} className={resolveProps(this.props, this.config, 'ProgressBar')} style={{visibility: isVisible ? 'visible' : 'hidden' }} >
      {this.renderProgressbar(value, progress)}
    </div>
  }
}

ProgressBar.propTypes = {
  value : PropTypes.number,
  progress : PropTypes.number,
  config : PropTypes.object
}